import { CHECKOUT_TAX_ACTIONS } from './checkoutTax.types'

export const setCheckoutTaxStatusAction = payload => ({
  type: CHECKOUT_TAX_ACTIONS.SET_STATUS,
  payload
})

export const setCheckoutTaxErrorsAction = payload => ({
  type: CHECKOUT_TAX_ACTIONS.SET_ERRORS,
  payload
})

export const clearCheckoutTaxErrorsAction = () => ({
  type: CHECKOUT_TAX_ACTIONS.CLEAR_ERRORS
})

export const setCheckoutTaxQuoteAction = payload => ({
  type: CHECKOUT_TAX_ACTIONS.SET_TAX_QUOTE,
  payload
})
